import './index.scss'

const Contact = () => 'Hello'

export default Contact
